import { handleActions } from 'redux-actions';
import { fromJS } from 'immutable';
import { State } from './model';


const Reducer = handleActions({
  'redeems/UPDATE_SELECTED_PRODUCT_CATEGORY_ID': (state, { payload }) => {
    return state.setIn(['selectedProductCategoryId'], payload.productCategoryId);
  },	
  'redeems/UPDATE_SELECTED_PRODUCT_ID': (state, { payload }) => {
    return state.setIn(['selectedProductId'], payload.productId);
  },
  'redeems/UPDATE_PRODUCTS': (state, { payload }) => {
    return state.setIn(['products'], fromJS(payload.products));
  },
  'redeems/UPDATE_PRODUCT_ID_LIST': (state, { payload }) => {
    return state.setIn(['productIdList'], fromJS(payload.productIdList));
  },
  'redeems/UPDATE_PRODUCT_CATEGORIES': (state, { payload }) => {
    return state.setIn(['productCategories'], fromJS(payload.productCategories));
  },
  'redeems/UPDATE_PRODUCT_CATEGORY_ID_LIST': (state, { payload }) => {
    return state.setIn(['productCategoryIdList'], fromJS(payload.productCategoryIdList));
  } 
}, State);

export default Reducer;